import AddressJson from "./addressJson";

export default class Address {
  line1: string | null;
  line2: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  country: string | null;

  constructor() {
    this.line1 = null;
    this.line2 = null;
    this.city = null;
    this.state = null;
    this.zipCode = null;
    this.country = null;
  }

  static fromJSON(json: AddressJson | null): Address {
    const address = new Address();

    if (json === null) {
      return address;
    }

    address.line1 = json.line1;
    address.line2 = json.line2;
    address.city = json.city;
    address.state = json.state;
    address.zipCode = json.zipCode;
    address.country = json.country;

    return address;
  }
}
